export default {
   namespaced: true,
   state: {
      loading: true,
      fileCategoryRefs: {}
   },
   getters: {

   },
   actions: {
      getFileCategoryRefs: function({commit}, param) {
         commit('SET_FILE_CATEGORY_LOADING', true);
         $.ajax({
                   type: "POST",
                   url: "/mediaplan/app/endpoints/json-api/ref/file-categories",
                   data: JSON.stringify(param.queryInput),
                   headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json'
                   }
                }).done(function (fileCategoryRefs) {
            commit('SET_FILE_CATEGORY_REFS', fileCategoryRefs);
            commit('SET_FILE_CATEGORY_LOADING', false);
         });
      }
   },
   mutations: {
      SET_FILE_CATEGORY_LOADING: function(state, loading) {
         state.loading = loading;
      },
      SET_FILE_CATEGORY_REFS: function (state, fileCategoryRefs) {
         state.fileCategoryRefs = fileCategoryRefs;
      }
   }
}